import walletApi from "apis/walletApi";
import { Bank3rdItem, BankDepositModel, bankQuick, winPayActive } from "models/bankModel";
import accountStyles from '../account/account-option/account-option.style';
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import styles from './deposit.styles';
import classNames from "classnames";
import BankDeposit from "./BankDeposit";
import Bank3rdDeposit from "./Bank3rdDeposit";
import UsdtDeposit from "./UsdtDeposit";
import { IoMdClose } from "react-icons/io";

const bBinBankList: { [key: string]: number } = {
    saigonbank: 970400,
    sacombank: 970403,
    agribank: 970405,
    dongabank: 970406,
    techcombank: 970407,
    bacabank: 970409,
    vietinbank: 970415,
    acb: 970416,
    bidv: 970418,
    mbbank: 970422,
    tienphongbank: 970423,
    shinhanbank: 970424,
    anbinhbank: 970425,
    scb: 970429,
    eximbank: 970431,
    vpbank: 970432,
    vietbank: 970433,
    vcb: 970436,
    seabank: 970440,
    maritimebank: 970426,
    saigon: 970400,
    sacom: 970403,
    agri: 970405,
    donga: 970406,
    techcom: 970407,
    mb: 970422,
    baca: 970409,
    vietin: 970415,
    tienphong: 970423,
    shinhan: 970424,
    anbinh: 970425,
    exim: 970431,
    vp: 970432,
    viet: 970433,
    sea: 970440,
    vietcom: 970436,
};

interface TabDeposit {
    label: string;
    value: 'BANK' | 'QUICK' | 'USDT';
}

const tabDeposit: TabDeposit[] = [
    {
        label: 'Chuyển Khoản Ngân Hàng',
        value: 'BANK',
    },
    {
        label: 'Chuyển Khoản Trực Tuyến',
        value: 'QUICK',
    },
    {
        label: 'Nạp USDT',
        value: 'USDT',
    },
];

function DepositPage() {

    const [tabSelect, setTabSelect] = useState<'BANK' | 'QUICK' | 'USDT'>('BANK');
    const vnPayChannels = ['VNPAY', 'V8PAY'];
    const [bankQuick, setBankQuick] = useState<BankDepositModel[]>([]);
    const [bankTransfer, setBankTransfer] = useState<BankDepositModel[]>([]);
    const [depositSelect, setDepositSelect] = useState<BankDepositModel>({} as BankDepositModel);
    const [depositCodeList, setDepositCodeList] = useState("");
    const [codeTransfer, setCodeTransfer] = useState('');
    const [loading, setLoading] = useState(false);
    const [isActve, setIsActve] = useState(false);
    const [vnPayBank, setVnPayBank] = useState(false);
    const [minMaxDeposit, setMinMaxDeposit] = useState<{ min: number; max: number }>({min: 200000, max: 300000000});

    const [bank3rdList, setBank3rdList] = useState<Bank3rdItem[]>([]);
    const [linkDeposit3rd, setLinkDeposit3rd] = useState('');
    const [winPaySubActive, setWinPaySubActive] = useState<bankQuick>({} as bankQuick);

    useEffect(() => {
        const initDeposit = async () => {
            try {
                const { data } = await walletApi.depositInit({});
                if(!data.msg) {
                    // const bankQuickData = data.paymentMethod.filter((item: BankDepositModel) => item.name === "ebank");
                    let bankQuickData: any;
                    let bankQuickAuto: any;
                    // const bankTransferData = data.paymentMethod.filter((item: BankDepositModel) => item.name === "autobank");
                    const ebankList: any[] = data.ebankList || [];
                    const isEbankActive = (name: string) => ebankList.some((e: any) => e.name === name && e.active === 1);

                    data.paymentMethod.forEach((el: any) => {
                        const key = el.name;
                        data[key] = {
                            title: el.displayname.replace('Chuyển khoản', 'CK'),
                            bankList: el.bankList
                        }
                        if(key === 'ebank') {
                            const banks3rd: any[] = [];
                            if(isEbankActive('wpay')) banks3rd.push({ icon: 'qrcode', channelName: 'WPAY', channelValue: 'wpay' });
                            if(isEbankActive('v8pay')) banks3rd.push({ icon: 'v8pay', channelName: 'V8PAY', channelValue: '003' });
                            if(isEbankActive('vnpay')) banks3rd.push({ icon: 'vnpay1', channelName: 'VNPAY', channelValue: 0 });
                            data['ebank'].bankList = [...data['ebank'].bankList, ...banks3rd];
                            bankQuickData = data['ebank'];
                        }
                        if(key === "autobank") {
                            const banks3rdAuto: any[] = [];
                            if(isEbankActive('v8pay')) banks3rdAuto.push({ icon: 'v8pay', channelName: "V8PAY", channelValue: '003' });
                            if(isEbankActive('vnpay')) banks3rdAuto.push({ icon: 'vnpay1', channelName: 'VNPAY', channelValue: 0 });
                            data['autobank'].bankList  = [...data['autobank'].bankList, ...banks3rdAuto];
                            bankQuickAuto = data['autobank'];
                        }
                    });

                    setBankQuick(bankQuickData.bankList);
                    setBankTransfer(bankQuickAuto.bankList);
                    const depositContent = data.paymentMethod[0].depositContent;
                    setDepositCodeList(depositContent);

                    // Active ngân hàng thường đầu tiên khi load
                    const firstBank = bankQuickAuto.bankList.find((b: any) => !vnPayChannels.includes(b.channelName));
                    if (firstBank) {
                        setDepositSelect(firstBank);
                        setCodeTransfer(depositContent);
                        setMinMaxDeposit({ min: firstBank.minamount, max: firstBank.maxamount });
                        generateQrCode({
                            accountNo: firstBank.bankcard,
                            accountName: firstBank.showbankcard,
                            acqId: bBinBankList[String(firstBank.accid).toLowerCase()],
                            addInfo: depositContent,
                            format: 'text',
                            template: 'qr_only',
                        }, firstBank);
                    }

                } else {
                    toast.error(data.msg);
                }
            } catch (error) {
                console.log(error);
            }
        };
        initDeposit();
    }, []);

    const resetBank = () => {
        setDepositSelect({} as BankDepositModel);
        setVnPayBank(false);
        setIsActve(false);
        setBank3rdList([]);
    }

    const setActiveBank = (data: any) => {
        setVnPayBank(true);
        setIsActve(true);
        if(linkDeposit3rd) setLinkDeposit3rd('');

        setLoading(true);
        setBank3rdList([]);
        setDepositSelect(data[0]);
        setWinPaySubActive(data[0]);
        getBankVnPay('V8PAY');
    }

    const changeTabBank = (tab: 'BANK' | 'QUICK' | 'USDT') => {
        if(tab === tabSelect) return;
            setTabSelect(tab);
            resetBank();
        if(linkDeposit3rd) setLinkDeposit3rd('');
        if(tab !== 'USDT') {
            setActiveBank(bankTransfer);
        }
    };

    const changeDepositType = (banktype: BankDepositModel) => {
        setDepositSelect(banktype);
        if (vnPayChannels.includes(banktype.channelName)) {
            setVnPayBank(true);
            setIsActve(true);
            if(linkDeposit3rd) setLinkDeposit3rd('');

            setLoading(true);
            setBank3rdList([]);
            if(banktype.channelName === "VNPAY") {
                changeVNPayBank();
            } else if(banktype.channelName === "V8PAY") {
                getBankVnPay(banktype.channelName);
                const selectedBank = bankQuick.find(bank => bank.channelName === banktype.channelName);
                if (selectedBank) {
                    setWinPaySubActive(selectedBank);
                }
            }
        } else {
            resetBank();
            if(banktype.id === depositSelect.id) {
                return;
            }
            const { maxamount, minamount } = banktype;
            setCodeTransfer(depositCodeList);
            setMinMaxDeposit({ min: minamount, max: maxamount });
            const payloadQrCode = {
                accountNo: banktype.bankcard,
                accountName: banktype.showbankcard,
                acqId: bBinBankList[String(banktype.accid).toLowerCase()],
                addInfo: depositCodeList,
                format: 'text',
                template: 'qr_only',
            };

            generateQrCode(payloadQrCode, banktype);
        }
    }

    const generateQrCode = async (payload: any, bankItem: BankDepositModel) => {
        try {
            const response = await fetch('https://api.vietqr.io/v2/generate', {
                method: 'POST',

                headers: {
                    'Content-Type': 'application/json',
                    'x-client-id': '424eff55-1bdd-4996-899b-5ac56547e620',
                    'x-api-key': '6e63c6dc-1749-491d-8c25-cf6815f68769',
                },

                body: JSON.stringify(payload),
            });
            const res = await response.json();
            if(res.code === '00') {
                const newDepositSelect = {...bankItem, qrurl: res.data.qrDataURL};
                setDepositSelect(newDepositSelect);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const changeGateWinPay = (gate: bankQuick) => {
        setWinPaySubActive(gate);
        if (vnPayChannels.includes(gate.channelName)) {
            getBankVnPay(gate.channelName);
        } else {
            getBankWPay();
        }
    }

    const changeVNPayBank = async () => {
        try {
            const { data } = await walletApi.vnPayDepositListBankTransfer({});
            if(!data.msg) {
                const bankSubArray = [];
                for (const key in data) {
                    const itemBankSub = {
                        bankName: data[key].value,
                        channelNo: 'bank_transfer',
                        actionName: data[key].label
                    };
                    bankSubArray.push(itemBankSub);
                }
                setBank3rdList(bankSubArray);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const getBankVnPay = async (channel: string) => {
        setLoading(true);
        setBank3rdList([]);
        if(channel === 'VNPAY') {
            try {
                const { data } = await walletApi.vnPayQrDepositListBankTransfer({});
                if(!data.msg) {
                    const bankSubArray = [];
                    for (const key in data) {
                        const itemBankSub = {
                            bankName: data[key].label,
                            channelNo: 'bank_qr',
                            actionName: ''
                        };
                        bankSubArray.push(itemBankSub);
                    }
                    setBank3rdList(bankSubArray);
                } else {
                    toast.error(data.msg);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        } else {
            try {
                const { data } = await walletApi.v8BankList({});
                if(!data.msg) {
                    const bankSubArray = [];
                    for (const key in data.data) {
                        const itemBankSub = {
                            bankName: data.data[key].bankName,
                            channelNo: '003',
                            actionName: data.data[key].bankCode
                        };
                        bankSubArray.push(itemBankSub);
                    }
                    setBank3rdList(bankSubArray);
                } else {
                    toast.error(data.msg);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        }
    };

    const getBankWPay = async () => {
        setLoading(true);
        setBank3rdList([]);
        try {
            const { data } = await walletApi.getListBankWinPay({});
            if(!data.msg) {
                const bankSubArray = [];
                for (const key in data.data[0][0].bankInforList) {
                    const itemBankSub = {
                        bankName: data.data[0][0].bankInforList[key].bankName,
                        channelNo: data.data[0][0].channelValue,
                        actionName: ''
                    };
                    bankSubArray.push(itemBankSub);
                }
                setBank3rdList(bankSubArray);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const submit3rdDeposit = async (data: { amount: string; bankName: string; channelNo: string }) => {
        setLinkDeposit3rd('');
        const payload = {
            ...data
        };
        setLoading(true);
        try {
            const { data } = await walletApi.orderWinPay(payload);
            if(!data.msg) {
                const res = data.data[0];
                setLinkDeposit3rd(res.targetUrl);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const submitVNPAYdDeposit = async (data: { amount: string; bankCode: string; channel: string }) => {
        setLinkDeposit3rd('');
        const payload = {
            ...data
        };
        setLoading(true);
        if(data.channel !== '003') {
            try {
                const { data } = await walletApi.vnPayDeposit(payload);
                if(!data.msg) {
                    const res = data.data[0];
                    setLinkDeposit3rd(res.data);
                } else {
                    toast.error(data.msg);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        } else {
            try {
                const { data } = await walletApi.v8Order(payload);
                if(!data.msg) {
                    const res = data.data[0];
                    setLinkDeposit3rd(res);
                } else {
                    toast.error(data.msg);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        }
        }

    const onClose = () => {
        setLinkDeposit3rd('');
    }

    return (
        <>
            <div className={accountStyles.wrap}>
                <h6 className={accountStyles.title}>Nạp Tiền</h6>
                <div className={styles.tabList}>
                    {tabDeposit.map((tab) => (
                        <div className={classNames(styles.tabItem, { active: tabSelect === tab.value })} key={tab.value}
                        onClick={() => changeTabBank(tab.value)}>{tab.label}</div>
                    ))}
                </div>
                {!linkDeposit3rd ? (
                    <div className={accountStyles.mw800}>
                        {/* bank tab */}
                        {tabSelect === 'BANK' && (
                            <div className={styles.bankGroup}>
                                <h6 className={styles.titleBankGroup}>
                                    {Object.keys(depositSelect).length > 0 ? (
                                        <>
                                            Bạn đang chọn thanh toán qua cổng <span>{depositSelect.name}</span>
                                        </>
                                    ) : (
                                        '1. Chọn ngân hàng'
                                    )}
                                </h6>

                                <div className={styles.bankList}>
                                    {bankTransfer.map((bank, index) => (
                                        <div className={classNames(styles.bankItem, {active: depositSelect.icon === bank.icon})} key={bank.icon || index}
                                        onClick={() => changeDepositType(bank)}>
                                            <div className={styles.bankItemInner}>
                                                <img src={require(`assets/images/bank-list/${bank.icon.toLocaleLowerCase()}.jpg`)} className={styles.bankIcon} alt="" />
                                                {depositSelect.icon === bank.icon && <img className={styles.iconBankSelect} src={require('assets/images/icons/tick-bank.png')} alt="" />}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* qick tab */}
                        {tabSelect === 'QUICK' && (
                            <div className={styles.bankGroup}>
                                {bankQuick.some(b => ['WPAY', 'V8PAY', 'VNPAY'].includes(b.channelName)) ? (
                                    <>
                                        <h6 className={styles.titleBankGroup}>
                                            {Object.keys(winPaySubActive).length > 0 ? (
                                                <>
                                                    1. Bạn đang chọn thanh toán qua cổng <span>{winPaySubActive.channelName}</span>
                                                </>
                                            ) : (
                                                '1. Chọn cổng thanh toán'
                                            )}
                                        </h6>
                                        <div className={styles.bankList}>
                                            {bankQuick.filter(b => ['WPAY', 'V8PAY', 'VNPAY'].includes(b.channelName)).map((bank) => (
                                                <div className={classNames(styles.bankItem, { active: winPaySubActive.channelName === bank.channelName })} key={bank.channelName} onClick={() => changeGateWinPay(bank)}>
                                                    <div className={styles.bankItemInner}>
                                                        <img className={`${styles.bankIcon}`} src={require(`assets/images/bank-list/${bank.icon.toLocaleLowerCase()}.jpg`)} alt="" />
                                                        <p>{bank.channelName}</p>
                                                        {winPaySubActive.channelName === bank.channelName && <img className={styles.iconBankSelect} src={require('assets/images/icons/tick-bank.png')} alt="" />}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <h6 className={styles.titleBankGroup}>Đang cập nhật thanh toán</h6>
                                )}
                            </div>
                        )}
                        {/* nạp qua chuyển khoản ngân hàng */}
                        {tabSelect === 'BANK' && <BankDeposit depositSelect={depositSelect} codeTransfer={codeTransfer} minMaxDeposit={minMaxDeposit} />}

                        {/* nạp chuyển khoản qua bên thứ 3 */}
                        {(tabSelect === "QUICK" && bankQuick.some(b => ['WPAY', 'V8PAY', 'VNPAY'].includes(b.channelName)) || (tabSelect === "BANK" && vnPayBank)) && (
                            <Bank3rdDeposit onWinPaySubActive={winPaySubActive} onSubmitVNPAY={submitVNPAYdDeposit} onSubmit3rd={submit3rdDeposit} minMaxDeposit={minMaxDeposit} bank3rdList={bank3rdList} activeSubList={isActve} />
                        )}

                        {/* nạp USDT */}
                        {tabSelect === 'USDT' && <UsdtDeposit />}
                    </div>
                ) : (
                    <div className={styles.iframeDeposit}>
                        <button type="button" onClick={onClose}>
                            <IoMdClose size={36} color="#2d276d" />
                        </button>
                        <iframe src={linkDeposit3rd} title="link-deposit"></iframe>
                    </div>
                )}
            </div>
        </>
    )
    
}

export default DepositPage;